import { useEffect, useState } from "react";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
import { useTopBeneficiariesData } from "../../mappers/useTopBeneficiariesData";
import type { TopBeneficiaryDisplayItem } from "../../types/topBeneficiaries";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import "../styles/AlternativStyle.scss";

interface CfoLineBarProps {
  title?: string;
}

const BAR_COLORS = ["#1F3C88", "#5B9BD5", "#E4572E", "#2E8B57", "#8E44AD"];

const BeneficiaryProgressBar = ({
  item,
  color,
}: {
  item: TopBeneficiaryDisplayItem;
  color: string;
}) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setWidth(item.percentage));
    return () => cancelAnimationFrame(frame);
  }, [item.percentage]);

  return (
    <div className="gx-boa-progress-track">
      <div
        className="gx-boa-progress-fill"
        style={{ width: `${width}%`, backgroundColor: color }}
      />
    </div>
  );
};

const renderBeneficiaryRow = (
  item: TopBeneficiaryDisplayItem,
  index: number,
  formatAmount: (item: TopBeneficiaryDisplayItem) => string,
) => {
  const color = BAR_COLORS[index % BAR_COLORS.length];

  const currencySymbol = gxCurrencyFormat(0, item.currency).symbol;

  return (
    <div className="gx-boa-row" key={item.id}>
      <div className="gx-boa-row-header">
        <span className="gx-p14-m gx-boa-account-name">{item.name}</span>
        <span className="gx-p14-b gx-boa-amount">
          {currencySymbol} {formatAmount(item)}
        </span>
      </div>
      <BeneficiaryProgressBar item={item} color={color} />
    </div>
  );
};

function CfoLineBar({ title }: CfoLineBarProps) {
  const { data, loading, error } = useTopBeneficiariesData();

  const formatAmount = (item: TopBeneficiaryDisplayItem) => {
    const isNegative = item.amount < 0;
    const formatResult = gxCurrencyFormat(Math.abs(item.amount), item.currency);
    return `${isNegative ? "-" : ""}${formatResult.integer}${formatResult.decimal ?? ""}`;
  };

  return (
    <div className="gx-card-box-cfo-linebar gx-main-balance-account">
      <div className="gx-Balance-by-Account-header">
        <span className="gx-p18-b gx-Balance-by-Account">
          {/* {title || "Top beneficiaries · this quarter"} */}
          Top beneficiaries · this quarter
        </span>
        <span className="gx-p10-m gx-Balance-by-Account">
          Where your money is going
        </span>
      </div>

      {loading ? (
        <div className="gx-bene-form-container-loading-overlay">
          <SubmitLoading />
        </div>
      ) : error ? (
        <div className="gx-p14-m gx-boa-error">{error}</div>
      ) : data.length === 0 ? (
        <div className="gx-p14-m gx-boa-empty">No data</div>
      ) : (
        <div className="gx-boa-list">
          {data.map((item, index) =>
            renderBeneficiaryRow(item, index, formatAmount),
          )}
        </div>
      )}
    </div>
  );
}

export default CfoLineBar;

// import { useEffect, useState } from "react";
// import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
// import { useTopBeneficiariesData } from "../../mappers/useTopBeneficiariesData";
// import type { TopBeneficiaryDisplayItem } from "../../types/topBeneficiaries";
// import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
// import "../styles/AlternativStyle.scss";

// interface CfoLineBarProps {
//   title?: string;
// }

// const BAR_COLORS = ["#1F3C88", "#5B9BD5", "#E4572E", "#2E8B57", "#8E44AD"];

// const BeneficiaryProgressBar = ({
//   item,
//   color,
// }: {
//   item: TopBeneficiaryDisplayItem;
//   color: string;
// }) => {
//   const [width, setWidth] = useState(0);

//   useEffect(() => {
//     const frame = requestAnimationFrame(() => setWidth(item.percentage));
//     return () => cancelAnimationFrame(frame);
//   }, [item.percentage]);

//   return (
//     <div className="gx-boa-progress-track">
//       <div
//         className="gx-boa-progress-fill"
//         style={{ width: `${width}%`, backgroundColor: color }}
//       />
//     </div>
//   );
// };

// const renderBeneficiaryRow = (
//   item: TopBeneficiaryDisplayItem,
//   index: number,
//   formatAmount: (item: TopBeneficiaryDisplayItem) => string,
// ) => {
//   const color = BAR_COLORS[index % BAR_COLORS.length];

//   return (
//     <div className="gx-boa-row" key={item.id}>
//       <div className="gx-boa-row-header">
//         <span className="gx-p14-m gx-boa-account-name">{item.name}</span>
//         <span className="gx-p14-b gx-boa-amount">
//           {item.currency} {formatAmount(item)}
//         </span>
//       </div>
//       <BeneficiaryProgressBar item={item} color={color} />
//     </div>
//   );
// };

// function CfoLineBar({ title }: CfoLineBarProps) {
//   const { data, loading, error } = useTopBeneficiariesData();

//   const formatAmount = (item: TopBeneficiaryDisplayItem) => {
//     const formatResult = gxCurrencyFormat(item.amount, item.currency);
//     return `${formatResult.integer}${formatResult.decimal ?? ""}`;
//   };

//   return (
//     <div className="gx-card-box-cfo-linebar gx-main-balance-account">
//       <div className="gx-Balance-by-Account-header">
//         <span className="gx-p18-b gx-Balance-by-Account">
//           {/* {title || "Top beneficiaries · this quarter"} */}
//           Top beneficiaries · this quarter
//         </span>
//         <span className="gx-p10-m gx-Balance-by-Account">
//           Where your money is going
//         </span>
//       </div>

//       {loading ? (
//         <div className="gx-bene-form-container-loading-overlay">
//           <SubmitLoading />
//         </div>
//       ) : error ? (
//         <div className="gx-p14-m gx-boa-error">{error}</div>
//       ) : data.length === 0 ? (
//         <div className="gx-p14-m gx-boa-empty">No data</div>
//       ) : (
//         <div className="gx-boa-list">
//           {data.map((item, index) =>
//             renderBeneficiaryRow(item, index, formatAmount),
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default CfoLineBar;
